import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './common/components/header/header.component';
import { SideMenuBarComponent } from './common/components/side-menu-bar/side-menu-bar.component';
import { SideMenuBarQAComponent } from './common/components/side-menu-bar-copy/side-menu-barqa.component';
import { MaterialModule } from './material.module';
import { ErrorInterceptor } from './common/interceptors/error.interceptor';
import { MockApiInterceptor } from './common/interceptors/mock-api.interceptor';
import { LandingPageComponent, QWeekBannerComponent } from './landing-page/landing-page.component';
import { FactoryInformationComponent, DialogSuccessComponent } from './factory-information/factory-information.component';
import { IncidentUploadComponent, IncidentUploadErrorPopupComponent } from './incident-upload/incident-upload.component';
import { IncidentUploadSQLComponent, IncidentUploadSQLErrorDetailsComponent, IncidentUploadSQLErrorPopupComponent } from './incident-upload-SQL/incident-upload-SQL.component';
import { QaMatrixCreationComponent, DashBoardDialogPopUpComponent } from './qa-matrix-creation/qa-matrix-creation.component';
import { DefectModeTabComponent } from './qa-matrix-creation/defect-mode-tab/defect-mode-tab.component';
import { FrequencyTabComponent } from './qa-matrix-creation/frequency-tab/frequency-tab.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { StandardInstructionComponent } from './standard-instruction/standard-instruction.component';
import { CostTabComponent } from './qa-matrix-creation/cost-tab/cost-tab.component';
import { DetectionPointTabComponent } from './qa-matrix-creation/detection-point-tab/detection-point-tab.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DpiCalPdcaComponent } from './qa-matrix-creation/dpi-cal-pdca/dpi-cal-pdca.component';
import { DummyComponent } from './common/components/dummy/dummy.component';
import { environment } from '../environments/environment';
import { DpiParetoChartComponent } from './dashboard/dpi-pareto-chart/dpi-pareto-chart.component';
import { PieChartComponent } from './dashboard/pie-chart/pie-chart/pie-chart.component';
import { PieChartPdcaComponent } from './dashboard/pie-chart/pie-chart-pdca/pie-chart-pdca.component';
import { ErrorPageComponent } from './common/components/error-page/error-page.component';
import { MaintenancePageComponent } from './common/components/maintenance/maintenance-page.component';
import { SideMenuBarDashboardComponent } from './common/components/side-menu-bar-dashboard/side-menu-bardashboard.component';
import { LossTreeComponent, AddLossTreeDialogPopUpComponent, DialogOverviewExampleDialogComponent } from './loss-tree/loss-tree.component';
import { TwoDigitDecimaNumberDirective } from './two-digit-decima-number.directive';
import { TableRowComponent } from './loss-tree/table-row/table-row.component';
import { HasRelativeTableComponent } from './loss-tree/has-relative-table/has-relative-table.component';
import { DashboardSqlComponent } from './dashboard-sql/dashboard-sql.component';
import { DpiParetoChartSqlComponent } from './dashboard-sql/dpi-pareto-chart-sql/dpi-pareto-chart-sql.component';
import { PieChartSqlComponent } from './dashboard-sql/pie-chart-sql/pie-chart-sql/pie-chart-sql.component';
import { PieChartPdcaSqlComponent } from './dashboard-sql/pie-chart-sql/pie-chart-sql-pdca/pie-chart-pdca-sql.component';
import { DatePipe, registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { CurrencyExchangeRateComponent } from './currency-exchangerate/currency-exchangerate.component';
import { ProjectStatusReportComponent } from './project-status-report/project-status-report.component';
import { DeleteIncidentDataComponent } from './delete-incident-data/delete-incident-data.component';
import { DeleteHistoryComponent } from './delete-history/delete-history.component';
import { QualityMatrixAnalyticsComponent } from './quality-matrix-analytics/quality-matrix-analytics.component';
import { ProcessParetoReportComponent } from './dashboard-sql/process-pareto-report/process-pareto-report.component';
import { ParetoReportComponent } from './dashboard-sql/pareto-report/pareto-report.component';
import { QualityMatrixDataComponent } from './quality-matrix-data/quality-matrix-data.component';
import { DefectsCountBlockComponent } from './dashboard-sql/defects-count-block/defects-count-block.component';
import { DpiReductionAnalysisComponent } from './dpi-reduction-analysis/dpi-reduction-analysis.component';
import { IncidentUploadStatusComponent } from './incident-upload-status/incident-upload-status.component';
import { ComparativeAnalyticsComponent } from './comparative-analytics/comparative-analytics.component';
import { AuthGuardMaintenance } from './common/services/auth-guard.service';
import { MsalGuard, MsalModule, MsalService} from '@azure/msal-angular';
export function loggerCallback(message) {
  // console.log('client logging' + message);
}
export const protectedResourceMap: [string, string[]][] = [

  ['https://graph.microsoft.com/v1.0/me',

    [

      'user.read',

      'profile',

      'User.ReadBasic.All',

      'Group.Read.All',

      'Directory.Read.All',

      'Group.ReadWrite.All'

    ]

  ]

];
const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;
registerLocaleData(en);

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SideMenuBarComponent,
    LandingPageComponent,
    FactoryInformationComponent,
    IncidentUploadComponent,
    IncidentUploadSQLComponent,
    QaMatrixCreationComponent,
    DefectModeTabComponent,
    FrequencyTabComponent,
    DashboardComponent,
    StandardInstructionComponent,
    CostTabComponent,
    DetectionPointTabComponent,
    DpiCalPdcaComponent,
    SideMenuBarQAComponent,
    DialogOverviewExampleDialogComponent,
    DummyComponent,
    DpiParetoChartComponent,
    DashBoardDialogPopUpComponent,
    DialogSuccessComponent,
    IncidentUploadErrorPopupComponent,
    PieChartComponent,
    PieChartPdcaComponent,
    ErrorPageComponent,
    MaintenancePageComponent,
    SideMenuBarDashboardComponent,
    IncidentUploadSQLErrorPopupComponent,
    IncidentUploadSQLErrorDetailsComponent,
    LossTreeComponent,
    TwoDigitDecimaNumberDirective,
    TableRowComponent,
    HasRelativeTableComponent,
    AddLossTreeDialogPopUpComponent,
    DashboardSqlComponent,
    DpiParetoChartSqlComponent,
    PieChartSqlComponent,
    PieChartPdcaSqlComponent,
    CurrencyExchangeRateComponent,
    ProjectStatusReportComponent,
    DeleteIncidentDataComponent,
    DeleteHistoryComponent,
    QualityMatrixAnalyticsComponent,
    ProcessParetoReportComponent,
    ParetoReportComponent,
    QualityMatrixDataComponent,
    DefectsCountBlockComponent,
    DpiReductionAnalysisComponent,
    IncidentUploadStatusComponent,
    ComparativeAnalyticsComponent,
    QWeekBannerComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MaterialModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MsalModule.forRoot({
      auth: environment.msalAuthConfig.auth,
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: isIE, // set to true for IE 11
      },
      framework: {
        unprotectedResources: ['https://www.microsoft.com/en-us/'],
        protectedResourceMap: new Map(protectedResourceMap)
      },
      system: {
        loadFrameTimeout: 30000,
        // logger: new Logger(loggerCallback, {
        //   correlationId: '1234',
        //   piiLoggingEnabled: true
        // })
      }
    }, {
      popUp: false,
      consentScopes: [
        'user.read',
        'openid',
        'profile',
      ],
      extraQueryParameters: {}
    }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: MockApiInterceptor, multi: true },
    DatePipe,
    AuthGuardMaintenance,
    MsalGuard,
    MsalService
  ],
  bootstrap: [AppComponent],
  entryComponents: [AppComponent, DialogOverviewExampleDialogComponent, DashBoardDialogPopUpComponent,
    DialogSuccessComponent, IncidentUploadErrorPopupComponent, IncidentUploadSQLErrorPopupComponent, AddLossTreeDialogPopUpComponent, IncidentUploadSQLErrorDetailsComponent, QWeekBannerComponent]
})
export class AppModule { }
